export default {
  lightTransparentGrey: '#fcfcfed4'
};
